module.exports = __webpack_public_path__ + "img/belfert.a480469f.jpg";